import { defineStore } from "pinia";
export const useGlobalSnackbarStore = defineStore("nuxt-spoferan-global-snackbar", {
  state: () => ({
    isVisible: false,
    props: {},
    listeners: {}
  }),
  actions: {
    showSnackbar(type, message, title = null, duration = 4500) {
      return new Promise((resolve) => {
        this.isVisible = true;
        this.props = {
          color: type,
          message,
          title,
          duration
        };
        this.listeners = {
          hide: () => {
            this.isVisible = false;
            this.props = {};
            this.listeners = {};
            resolve();
          }
        };
      });
    }
  }
});
